import PropTypes from 'prop-types';
import { Eye, FileText } from 'lucide-react';
import { Badge, Button } from '../ui';

/**
 * Card pour afficher un modèle de sondage
 * @component
 */
function TemplateCard({ template, onPreview, onUse }) {
  const questionsCount = template.questions_count || 0;
  console.log(template)
  return (
    <div className="rounded-lg border bg-card text-card-foreground shadow-sm hover:shadow-elevated transition-all duration-300 group h-full flex flex-col">
      <div className="p-5 flex flex-col flex-1">
        {/* Header */}
        <div className="space-y-3 flex-1">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-display font-semibold text-foreground text-lg group-hover:text-primary transition-colors line-clamp-2">
              {template.title}
            </h3>
            <Badge variant="outline" className="bg-muted text-muted-foreground border-muted shrink-0">
              Brouillon
            </Badge>
          </div>
          
          <p className="text-sm text-muted-foreground line-clamp-2 min-h-[40px]">
            {template.description || 'Aucune description'}
          </p>

          {/* Infos */}
          <div className="flex items-center gap-3 text-xs text-muted-foreground pt-2">
            <span className="flex items-center gap-1.5">
              <FileText className="h-3.5 w-3.5" />
              {questionsCount} question{questionsCount > 1 ? 's' : ''}
            </span>
            {template.category && (
              <Badge variant="outline" className="text-xs">
                {template.category === "EVENT" ? "Événementiel" : 
                 template.category === "INTERNAL" ? "Interne" : 
                 template.category === "EXTERNAL" ? "Externe" : 
                 template.category === "SATISFACTION" ? "Satisfaction" :
                 template.category === "FEEDBACK" ? "Feedback" :
                 template.category}
              </Badge>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 pt-4 mt-4 border-t">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onPreview(template)}
            className="flex-1 gap-2"
          >
            <Eye className="h-4 w-4" />
            Aperçu
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={() => onUse(template)}
            className="flex-1 gap-2"
          >
            Utiliser ce modèle
          </Button>
        </div>
      </div>
    </div>
  );
}

TemplateCard.propTypes = {
  template: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    category: PropTypes.string,
    questions: PropTypes.array,
  }).isRequired,
  onPreview: PropTypes.func.isRequired,
  onUse: PropTypes.func.isRequired,
};

export default TemplateCard;
